import React from 'react';
import * as Phoenix from 'phoenix';
import ModalToSelectSeats from '../../base/ModalToSelectSeats/ModalToSelectSeats';
import ModalToSelectSeatsSocket from '../../base/ModalToSelectSeats/ModalToSelectSeatsSocket';

class ShuttleSelectSeats extends React.Component {

  constructor() {
    super();
    let segment = 0;
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      const uriSegment = urlParams.get('segment');
      if (uriSegment) segment = uriSegment;
    }
    this.state = {
      shuttleDetails: {
        data: {
          passengersS: {}
        }
      },
      selectedSeats: [],
      blockedSeats: [],
      currentSegment: segment
    };
    this.selectSeat = this.selectSeat.bind(this);
    this.unSelectSeat = this.unSelectSeat.bind(this);
    this.blockSeat = this.blockSeat.bind(this);
    this.unblockSeat = this.unblockSeat.bind(this);
  }

  componentDidMount() {
    const { page } = this.props;
    const { currentSegment } = this.state;
    let shuttleDetails;
    if (typeof window !== 'undefined') {
      console.log(page);
      if (page === 'shuttleSelectSeatsReturn') {
        console.log("USING RETURN DETAILS");
        shuttleDetails = JSON.parse(window.localStorage.getItem('CBX_Shuttle_Return_Details'));
      } else {
        console.log("USING NON RETURN DETAILS");
        shuttleDetails = JSON.parse(window.localStorage.getItem('CBX_Shuttle_Details'));
      }
    }
    if (!shuttleDetails.data.someDetails.trip) {
      this.setState({ shuttleDetails });
      return;
    }
    const {
      name: scheduleId,
      legFrom,
      legTo,
      routeId,
      manifestDate,
      seatMapId,
      from,
      to
    } = shuttleDetails.data.someDetails.trip.segments[currentSegment];
    console.log("SegmentData = %j", shuttleDetails.data.someDetails.trip.segments[currentSegment]);
    const accessticket = shuttleDetails.data.accessToken.ticket;
    const idForLiveSeatmap = `${routeId}_${scheduleId}_${manifestDate}`;

    const socket = new Phoenix.Socket(process.env.GATSBY_BETTEREZ_SOCKET_ENDPOINT, { params: { token: accessticket } });
    socket.connect();
    const channel = socket.channel(`seatmap:${idForLiveSeatmap}`, { leg_from: `${legFrom}`, leg_to: `${legTo}` });
    channel.join()
      .receive('ok', (msg) => {
        console.log('Joined', msg);
      })
      .receive('error', (err) => {
        console.log('failed join', err.reason);
      });

    channel.on('seat:selected', (msg) => {
      const selectedSeat = msg.selected_seat;
      console.log('seat:selected', selectedSeat);
      const {
        selectedSeats,
        blockedSeats
      } = this.state;
      if (selectedSeats.filter(({ id: seatId }) => (seatId === selectedSeat.seat_id)).length === 0
        && !blockedSeats.includes(selectedSeat.seat_id)) {
        blockedSeats.push(selectedSeat.seat_id);
        this.setState({ blockedSeats });
      }
    });

    channel.on('seat:unselected', (msg) => {
      const unselectedSeat = msg.unselected_seat;
      const {
        blockedSeats
      } = this.state;
      console.log('seat:unselected', unselectedSeat);
      const blockedSeatIdx = blockedSeats.findIndex((seatId) => {
        console.log(seatId);
        return unselectedSeat.seat_id === seatId;
      });
      console.log(blockedSeatIdx);
      if (blockedSeatIdx !== -1) {
        blockedSeats.splice(blockedSeatIdx, 1);
        this.setState({ blockedSeats });
      }
    });

    channel.on('sync:join', (msg) => {
      console.log("sync:join", msg.seats);
      const { blockedSeats } = this.state;
      let changed = false;
      msg.seats.forEach((seat) => {
        console.log('block', seat.seat_id);
        if (!blockedSeats.includes(seat.seat_id)) {
          blockedSeats.push(seat.seat_id);
          changed = true;
        }
      });
      if (changed) {
        this.setState({ blockedSeats });
      }
    });

    channel.on('sync:seats', (msg) => {
      const {
        blockedSeats,
        selectedSeats
      } = this.state;
      let changedBlocked = false;
      let changedSelected = false;
      msg.expired.forEach((expired) => {
        console.log('unblock', expired.seat_id);
        const blockedSeatIndex = blockedSeats.findIndex((seat) => {
          return seat === expired.seat_id;
        });
        const selectedSeatIndex = selectedSeats.findIndex((seat) => {
          return seat === expired.seat_id;
        });
        if (blockedSeatIndex >= 0) {
          blockedSeats.splice(blockedSeatIndex, 1);
          changedBlocked = true;
        }
        if (selectedSeatIndex >= 0) {
          selectedSeats.splice(selectedSeatIndex, 1);
          changedSelected = true;
        }
      });
      const updateObject = {};
      if (changedBlocked) {
        updateObject.blockedSeats = blockedSeats;
      }
      if (changedSelected) {
        updateObject.selectedSeats = selectedSeats;
      }
      if (changedBlocked || changedSelected) {
        this.setState(updateObject);
      }
    });

    this.setState({
      shuttleDetails,
      channel,
      socket,
      legFrom,
      legTo,
      seatMapId,
      scheduleId,
      from,
      to
    });

  }


  componentWillUnmount() {
    const { socket } = this.state;
    if (!socket) return;
    socket.disconnect();
  }

  unSelectSeat = (selector, rowData) => {
    const {
      channel,
      legFrom,
      legTo,
      selectedSeats,
      seatMapId,
      scheduleId,
      currentSegment: segment
    } = this.state;
    const {
      shuttlePassengers
    } = this.props;
    let seatData = selector;
    let seatNumber = selector;
    let seatId = selector;
    if (channel) {
      const payload = {
        seat: {
          leg_from: `${legFrom}`,
          leg_to: `${legTo}`,
          seat_id: selector
        },
        ttl_sec: 600
      };
      const [sectionName, rowLabel, btzseatNumber] = rowData.split('-');
      seatData = {
        seatMapId,
        scheduleId,
        sectionName,
        rowLabel,
        seatNumber: btzseatNumber,
        seatId: selector,
      };
      seatNumber = btzseatNumber;
      channel.push('seat:unselected', payload);
    }
    const seatIdx = selectedSeats.findIndex((seat) => {
      return seat.number === seatNumber && seat.id === selector;
    });
    const {
      onSelectedSeat: propsOnSelectedSeat,
      selectedSeat: propsSelectedSeat
    } = this.props;

    if (seatIdx !== -1) {
      selectedSeats.splice(seatIdx, 1);
      propsSelectedSeat.splice(seatIdx, 1);
    }
    this.setState({ selectedSeats });
    propsOnSelectedSeat(propsSelectedSeat);
  };

  selectSeat = (selector, rowData) => {
    const {
      channel,
      legFrom,
      legTo,
      selectedSeats,
      seatMapId,
      scheduleId,
      currentSegment: segment
    } = this.state;
    const {
      shuttlePassengers
    } = this.props;
    let seatData = selector;
    let seatNumber = selector;
    let seatId = selector;
    if (channel) {
      const payload = {
        seat: {
          leg_from: `${legFrom}`,
          leg_to: `${legTo}`,
          seat_id: selector
        },
        ttl_sec: 600
      };
      const [sectionName, rowLabel, btzseatNumber] = rowData.split('-');
      seatData = {
        seatMapId,
        scheduleId,
        sectionName,
        rowLabel,
        seatNumber: btzseatNumber,
        seatId: selector,
        segment
      };
      seatNumber = btzseatNumber;
      channel.push('seat:selected', payload);
    }
    selectedSeats.push({number: seatNumber, id: selector });
    this.setState({ selectedSeats });
    const {
      onSelectedSeat: propsOnSelectedSeat,
      selectedSeat: propsSelectedSeat
    } = this.props;
    propsSelectedSeat.push(seatData);
    propsOnSelectedSeat(propsSelectedSeat);
  };

  blockSeat = (selector) => {
  }

  unblockSeat(selector) {
  }

  render() {
    const {
      shuttleDetails,
      blockedSeats,
      selectedSeats,
      from,
      to,
      socket
    } = this.state;
    if (socket) {
      return (
        <ModalToSelectSeatsSocket
          {...this.props}
          from={from}
          to={to}
          onSelectedSeat={this.selectSeat}
          onUnSelectSeat={this.unSelectSeat}
          shuttleDetails={shuttleDetails}
          blockedSeats={blockedSeats}
          selectedSeat={selectedSeats}
        />
      );
    } else {
      return (
        <ModalToSelectSeats {...this.props} />
      );
    }
  }
}

export default ShuttleSelectSeats;
